import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const CustomTooltip = ({ title, placement = "top", children }) => {
  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: '#000',
            color: 'white',
          },
        },
        arrow: {
          sx: {
            color: '#000',
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
